import { IFieldInstance } from "../../types/fieldInstance.interface";
import { transformedData } from "./getTransformedData";
import { findFormfieldById } from "./hashTable";
import {
  checkIncidentType,
  shouldFieldRender,
  shouldRenderInTab,
} from "./viewModelMethods";

// use getTransformedData, return id as key, and condition as value
const { unnamed: unnamedFields, ...namedFields } = transformedData;

export const createViewModel = (
  fields: { [x: string]: any[] | IFieldInstance[] } = namedFields
) => {
  // change types
  return function (
    values: any,
    incidentType: string,
    activeTab: string,
    findFieldById: any = findFormfieldById,
    isStaticViewModel: boolean = false,
    allFormFields?: IFieldInstance[]
  ) {
    const viewModel: any = {};
    const allFields: IFieldInstance[] =
      allFormFields ?? Object.values(fields).flat();

    allFields.forEach((field: IFieldInstance) => {
      if (!viewModel[field.id] && !isStaticViewModel) {
        viewModel[field.id] =
          checkIncidentType(incidentType, field.incidentType) &&
          shouldRenderInTab(field.tab, incidentType, activeTab) &&
          shouldFieldRender(field, values, findFieldById);
      } else {
        viewModel[field.id] =
          checkIncidentType(incidentType, field.incidentType) &&
          shouldFieldRender(field, values, findFieldById);
      }
      // what happens if two fields share the same id?
    });
    return viewModel;
  };
};

export const getViewModel = createViewModel(namedFields);
